import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import { ctkm_mytv_bg, mytv_Badge_check, mytv_logo, mytv_Present_box, mytv_Television_play } from 'assets/landingPageMyTV/images';

// constant
const LandingPageMyTV = () => {
  const [scrollTop, setScrollTop] = useState(0);

  const handleScroll = event => {
    setScrollTop(event.currentTarget.scrollTop);
  };

  useEffect(() => {
  }, []);
  
  return (
    <div id='mytv-ldp' onScroll={handleScroll}>
      <img className='topbanner' src={ctkm_mytv_bg} alt="" srcset="" />
      <div className='logo'>
        <img src={mytv_logo} alt="" srcset="" /><span className='logo-title'>MyTV</span>
      </div>
      <div className='title'>Đăng ký liền tay, nhận ưu đãi lên tới 06 tháng cước Truyền hình MyTV</div>
      {scrollTop < 572 && <div className='reg-button'><a href='myvnpt://registerNow' style={{textDecorationLine: 'none'}}><button type="button">Đăng ký ngay</button></a></div>}
      {scrollTop >= 572 && <div className='reg-button reg-button-fix-bottom'><a href='myvnpt://registerNow' style={{textDecorationLine: 'none'}}><button type="button">Đăng ký ngay</button></a></div>}
      <div className='desc-reg-button'>Chỉ từ thêm 10.000đ/tháng</div>
      <div className='specialoffer'>
        <div className='specialoffer-item'>
          <img className="specialoffer-item-img" src={mytv_Present_box} alt="" srcset="" />
          <div className='specialoffer-item-rightcol'>
            <div className='specialoffer-item-rightcol-title'>Ưu đãi dành riêng cho khách hàng VNPT</div>
            <div className='specialoffer-item-rightcol-desc'>Ưu đãi truyền hình MyTV 6 tháng được +3 tháng, 12 tháng được +6 tháng</div>
          </div>
        </div>
        <div className='specialoffer-item'>
          <img className="specialoffer-item-img" src={mytv_Television_play} alt="" srcset="" />
          <div className='specialoffer-item-rightcol'>
            <div className='specialoffer-item-rightcol-title'>Trải nghiệm mãn nhãn cùng MyTV</div>
            <div className='specialoffer-item-rightcol-desc'>Thưởng thức trọn vẹn các giải đấu thể thao và 200 kênh truyền hình trong nước và quốc tế</div>
          </div>
        </div>
        <div className='specialoffer-item'>
          <img className="specialoffer-item-img" src={mytv_Badge_check} alt="" srcset="" />
          <div className='specialoffer-item-rightcol'>
            <div className='specialoffer-item-rightcol-title'>Đăng nhập 1 tài khoản trên 5 thiết bị</div>
            <div className='specialoffer-item-rightcol-desc'>Tài khoản đăng nhập được trên 5 thiết bị và sử dụng đồng thời trên 2 thiết bị bất kỳ</div>
          </div>
        </div>
      </div>
      <div className='grey-line'></div>
      <div className='policy_exp'>
        <div className='policy_exp-wrapper'>
          <div className='policy_exp-wrapper-title'>Chính sách ưu đãi mới nhất dành riêng cho kH sử dụng Internet VNPT</div>
          <div className='policy_exp-wrapper-desc'>Đăng ký gói Truyền hình MyTV: 6 tháng + 3 tháng hoặc 12 tháng + 6 tháng.<br /><br />
            Sử dụng dịch vụ Internet VNPT, chỉ từ 30.000đ để có combo Internet VNPT - Truyền hình MyTV, với đường truyền Internet hàng đầu tại Việt Nam và Truyền hình MyTV</div>
        </div>
        <div className='policy_exp-wrapper'>
          <div className='policy_exp-wrapper-title'>Trải nghiệm mãn nhãn cùng MyTV</div>
          <div className='policy_exp-wrapper-desc'>Gần 200 kênh truyền hình đa dạng từ trong nước đến quốc tế như VTV, VTVcab, HTV, HBO, Max, Box Hit….<br /><br />
            Có thể thưởng thức các giải đấu thể thao hàng đầu thế giới như MotoGP, giải Cầu lông thế giới BWF, giải Bóng bàn thế giới WTT, giải bóng đá Saudi Pro League/RSL, The Masters, US Open, Wimbledon, và nhiều giải đấu khác.<br /><br />
            Kho VOD cung cấp các sự kiện thể thao, highlight trận đấu và tin tức thể thao hàng ngày.<br /><br />
            Với MyTV, bạn có thể thưởng thức thế giới thể thao mọi lúc mọi nơi, chỉ cần một tài khoản đăng nhập trên 5 thiết bị và sử dụng đồng thời trên 2 thiết bị bất kỳ như SmartTV, Smartphone, Tablet</div>
        </div>
      </div>
    </div>
  );
}

export default LandingPageMyTV;
